const photoBarUploadingFormEquip = {
  typography: 'wait for the file to upload'
};

export default photoBarUploadingFormEquip;
